import { Box } from '@coolblue-development/becky';
import { useState } from 'react';
import { EmailMessage } from '../../../../../models/Email';
import EmailHeaderContainer from './EmailHeaderContainer';
import { useProcessedEmailHtml } from '../../../hooks/useProcessedEmailHtml';
import ReceivedEmailAttachmentChips from './ReceivedEmailAttachmentChips';
import { Alert } from '@coolblue-development/freddy';

interface EmailMessageItemProps {
  message: EmailMessage;
  index: number;
  initiallyCollapsed?: boolean;
  onAttachmentDownloadError?: () => void;
}

const EmailMessageItem = ({
  message,
  index,
  initiallyCollapsed = true,
  onAttachmentDownloadError
}: EmailMessageItemProps): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(initiallyCollapsed);
  const getProcessedEmailHtml = useProcessedEmailHtml();
  const { attachments, hasRejectedAttachments, contactId, bodyHtml } = message;
  const hasAttachments = attachments && attachments.length > 0;

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <EmailHeaderContainer message={message} onClick={() => setIsCollapsed(!isCollapsed)} isCollapsed={isCollapsed} />

      {!isCollapsed && (
        <Box
          id={`email-body-${index}`}
          sx={{
            marginX: '16px',
            marginBottom: '16px',
            borderRight: '1px solid #DDDDDD',
            borderLeft: '1px solid #DDDDDD',
            borderBottom: '1px solid #DDDDDD',
            borderRadius: '0 0 4px 4px',
            padding: '12px',
            maxHeight: '400px',
            overflow: 'auto',
            '& img': { maxWidth: '100%' },
            '& table': { maxWidth: '100%' }
          }}
        >
          {hasRejectedAttachments ? (
            <Alert
              description="One or more attachments couldn't be opened."
              intent="error"
              sx={{ marginBottom: '12px' }}
            />
          ) : (
            hasAttachments && (
              <ReceivedEmailAttachmentChips
                attachments={attachments}
                contactId={contactId}
                onDownloadError={onAttachmentDownloadError}
              />
            )
          )}
          <Box dangerouslySetInnerHTML={{ __html: getProcessedEmailHtml(bodyHtml || '<em>No content</em>') }} />
        </Box>
      )}
    </Box>
  );
};

export default EmailMessageItem;
